export default "__VITE_ASSET__DTZURtkh__"